import { render, staticRenderFns } from "./FreshWorks.vue?vue&type=template&id=412272e1&"
import script from "./FreshWorks.vue?vue&type=script&lang=js&"
export * from "./FreshWorks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports